import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimatedSection from '../components/AnimatedSection';
import { rooms, amenities, testimonials, WHATSAPP_NUMBER } from '../data/siteData';

/* ─── Icon Components ─── */
function AmenityIcon({ type }) {
    const icons = {
        food: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8.25v-1.5m0 1.5c-1.355 0-2.697.056-4.024.166C6.845 8.51 6 9.473 6 10.608v2.513m6-4.87c1.355 0 2.697.055 4.024.165C17.155 8.51 18 9.473 18 10.608v2.513m-3-4.87v-1.5m-6 1.5v-1.5m12 9.75l-1.5.75a3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0 3.354 3.354 0 00-3 0 3.354 3.354 0 01-3 0L3 16.5m15-3.38a48.474 48.474 0 00-6-.37c-2.032 0-4.034.126-6 .37m12 0c.39.049.777.102 1.163.16 1.07.16 1.837 1.094 1.837 2.175v5.17c0 .62-.504 1.124-1.125 1.124H4.125A1.125 1.125 0 013 20.625v-5.17c0-1.08.768-2.014 1.837-2.174A47.78 47.78 0 016 13.12M12.265 3.11a.375.375 0 11-.53 0L12 2.845l.265.265z" />
            </svg>
        ),
        campfire: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.047 6.51 6.51 0 009 4.382a6.475 6.475 0 003-1.168 6.475 6.475 0 003.362 2z" />
            </svg>
        ),
        view: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
        ),
        lake: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
            </svg>
        ),
        nature: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.115 5.19l.319 1.913A6 6 0 008.11 10.36L9.75 12l-.387.775c-.217.433-.132.956.21 1.298l1.348 1.348c.21.21.329.497.329.795v1.089c0 .426.24.815.622 1.006l.153.076c.433.217.956.132 1.298-.21l.723-.723a8.7 8.7 0 002.288-4.042 1.087 1.087 0 00-.358-1.099l-1.33-1.108c-.251-.209-.563-.372-.895-.416a3 3 0 01-2.4-2.96V6.525c0-.604-.394-1.12-.943-1.32a5.96 5.96 0 00-3.265-.012z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
            </svg>
        ),
        parking: (
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
            </svg>
        ),
    };
    return icons[type] || icons.view;
}

function StarIcon() {
    return (
        <svg className="w-4 h-4 text-gold-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
    );
}

/* ─── Booking Form ─── */
function BookingForm() {
    const [formData, setFormData] = useState({
        room: '',
        checkIn: '',
        checkOut: '',
    });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { room, checkIn, checkOut } = formData;
        if (!room || !checkIn || !checkOut) return;

        const roomName = rooms.find(r => r.id === room)?.name || room;
        const message = `Hello! I'd like to check availability at UC Eden Valley.%0A%0A` +
            `🏠 Room: ${roomName}%0A` +
            `📅 Check-in: ${checkIn}%0A` +
            `📅 Check-out: ${checkOut}%0A%0A` +
            `Please let me know if this is available. Thank you!`;

        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
    };

    // Minimum date is today
    const today = new Date().toISOString().split('T')[0];

    return (
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="flex flex-col gap-2">
                <label className="text-xs font-sans font-semibold tracking-wider uppercase text-gray-500 dark:text-gray-400">
                    Select Room
                </label>
                <select
                    name="room"
                    value={formData.room}
                    onChange={handleChange}
                    required
                    className="px-4 py-3.5 rounded-xl bg-gray-50 dark:bg-royal-600/50 border border-gray-200 dark:border-gold-500/10 text-gray-900 dark:text-white font-sans text-sm focus:outline-none focus:ring-2 focus:ring-gold-500/30 focus:border-gold-500 transition-all duration-300 appearance-none cursor-pointer"
                >
                    <option value="">Choose a room</option>
                    {rooms.map(room => (
                        <option key={room.id} value={room.id}>{room.name}</option>
                    ))}
                </select>
            </div>

            <div className="flex flex-col gap-2">
                <label className="text-xs font-sans font-semibold tracking-wider uppercase text-gray-500 dark:text-gray-400">
                    Check-in Date
                </label>
                <input
                    type="date"
                    name="checkIn"
                    value={formData.checkIn}
                    onChange={handleChange}
                    min={today}
                    required
                    className="px-4 py-3.5 rounded-xl bg-gray-50 dark:bg-royal-600/50 border border-gray-200 dark:border-gold-500/10 text-gray-900 dark:text-white font-sans text-sm focus:outline-none focus:ring-2 focus:ring-gold-500/30 focus:border-gold-500 transition-all duration-300"
                />
            </div>

            <div className="flex flex-col gap-2">
                <label className="text-xs font-sans font-semibold tracking-wider uppercase text-gray-500 dark:text-gray-400">
                    Check-out Date
                </label>
                <input
                    type="date"
                    name="checkOut"
                    value={formData.checkOut}
                    onChange={handleChange}
                    min={formData.checkIn || today}
                    required
                    className="px-4 py-3.5 rounded-xl bg-gray-50 dark:bg-royal-600/50 border border-gray-200 dark:border-gold-500/10 text-gray-900 dark:text-white font-sans text-sm focus:outline-none focus:ring-2 focus:ring-gold-500/30 focus:border-gold-500 transition-all duration-300"
                />
            </div>

            <div className="flex flex-col justify-end">
                <button
                    type="submit"
                    className="btn-primary w-full gap-2 text-sm"
                >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                    Check Availability
                </button>
            </div>
        </form>
    );
}

/* ─── Home Page ─── */
export default function HomePage() {
    return (
        <main>
            {/* ═══ HERO ═══ */}
            <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
                {/* Background image */}
                <img
                    src="/images/surroundings/valley.webp"
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                />

                <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
                    {/* <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm mb-8 animate-fade-in">
                        <span className="w-2 h-2 rounded-full bg-gold-400 animate-pulse" />
                        <span className="text-white/80 font-sans text-xs tracking-widest uppercase">Kookal, Kodaikanal</span>
                    </div> */}

                    <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 animate-slide-up leading-[1.1]">
                        UC <span className="italic text-gold-300">Eden</span> Valley
                    </h1>

                    <p className="font-body text-xl md:text-2xl text-white/70 max-w-2xl mx-auto mb-10 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        A serene retreat nestled in the misty hills of Kodaikanal, where <em className="text-gold-300">comfort</em> meets the untouched beauty of nature.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        <Link to="/rooms" className="btn-primary text-base px-10">
                            Explore Rooms
                        </Link>
                        <Link to="/gallery" className="btn-outline border-white/30 text-white hover:bg-white/10 hover:border-white/50 text-base px-10">
                            View Gallery
                        </Link>
                    </div>
                </div>
            </section>

            {/* ═══ BOOKING STRIP ═══ */}
            <section className="relative z-20 -mt-12 px-4 sm:px-6 lg:px-8">
                <div className="container-custom">
                    <div className="glass-card p-6 md:p-8 shadow-2xl">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="w-2 h-2 rounded-full bg-gold-500" />
                            <h2 className="font-sans text-xs font-semibold tracking-widest uppercase text-gold-600 dark:text-gold-400">
                                Check Availability
                            </h2>
                        </div>
                        <BookingForm />
                    </div>
                </div>
            </section>

            {/* ═══ WELCOME / ABOUT SECTION ═══ */}
            <section className="section-padding">
                <div className="container-custom">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                        <AnimatedSection>
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-8 h-px bg-gold-500" />
                                <span className="font-sans text-xs font-semibold tracking-widest uppercase text-gold-600 dark:text-gold-400">
                                    Welcome to Eden Valley
                                </span>
                            </div>
                            <h2 className="heading-section text-gray-900 dark:text-white mb-6">
                                Where the <span className="italic text-gold-600 dark:text-gold-400">Hills</span> Whisper & <span className="italic text-gold-600 dark:text-gold-400">Stars</span> Shine
                            </h2>
                            <p className="text-body-lg text-gray-600 dark:text-gray-300 mb-6">
                                Perched high in the tranquil village of Kookal, UC Eden Valley is more than a homestay — it's an experience.
                                Surrounded by ancient Shola forests, rolling grasslands, and the misty charm of Kodaikanal,
                                every moment here is a return to nature's embrace.
                            </p>
                            <p className="text-body-lg text-gray-600 dark:text-gray-300 mb-8">
                                Just a stone's throw from the pristine Kookal Lake, our property offers breathtaking valley views,
                                warm hospitality, home-cooked meals, and the kind of silence that heals.
                            </p>
                            <div className="grid grid-cols-3 gap-6">
                                {[
                                    { number: '4', label: 'Rooms' },
                                    { number: '35', label: 'Guests' },
                                    { number: '5★', label: 'Experience' },
                                ].map((stat, i) => (
                                    <div key={i} className="text-center">
                                        <div className="font-display text-3xl font-bold text-gold-600 dark:text-gold-400">{stat.number}</div>
                                        <div className="font-sans text-xs tracking-wider uppercase text-gray-500 dark:text-gray-400 mt-1">{stat.label}</div>
                                    </div>
                                ))}
                            </div>
                        </AnimatedSection>

                        <AnimatedSection delay={0.2}>
                            <div className="relative">
                                <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                                    <img
                                        src="/images/hero/property.webp"
                                        alt="UC Eden Valley property"
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                {/* Decorative frame */}
                                <div className="absolute -bottom-4 -right-4 w-full h-full rounded-2xl border-2 border-gold-500/20 -z-10" />
                            </div>
                        </AnimatedSection>
                    </div>
                </div>
            </section>

            {/* ═══ ROOMS PREVIEW ═══ */}
            <section className="section-padding bg-gray-50 dark:bg-royal-600/20">
                <div className="container-custom">
                    <AnimatedSection className="text-center mb-16">
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <div className="w-8 h-px bg-gold-500" />
                            <span className="font-sans text-xs font-semibold tracking-widest uppercase text-gold-600 dark:text-gold-400">
                                Our Rooms
                            </span>
                            <div className="w-8 h-px bg-gold-500" />
                        </div>
                        <h2 className="heading-section text-gray-900 dark:text-white mb-4">
                            Handpicked <span className="italic text-gold-600 dark:text-gold-400">Comfort</span>
                        </h2>
                        <p className="text-body-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
                            From elegant luxury rooms to cozy bunk spaces for groups,
                            each room is designed to make your stay unforgettable.
                        </p>
                    </AnimatedSection>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                        {rooms.map((room, index) => (
                            <AnimatedSection key={room.id} delay={index * 0.1}>
                                <div className="group glass-card overflow-hidden hover:shadow-2xl hover:shadow-gold-500/5 transition-all duration-500">
                                    {/* Image */}
                                    <div className="aspect-[16/10] relative overflow-hidden">
                                        <img
                                            src={room.images[0]}
                                            alt={room.name}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                        />
                                        <div className="absolute top-4 left-4">
                                            <span className={`px-3 py-1 rounded-full text-xs font-sans font-semibold tracking-wider uppercase ${room.type === 'luxury'
                                                ? 'bg-gold-500/90 text-white'
                                                : 'bg-forest-600/90 text-white'
                                                }`}>
                                                {room.type === 'luxury' ? 'Luxury' : 'Bunker'}
                                            </span>
                                        </div>
                                    </div>
                                    {/* Content */}
                                    <div className="p-6">
                                        <div className="flex items-center justify-between mb-2">
                                            <h3 className="font-display text-xl font-bold text-gray-900 dark:text-white">
                                                {room.name}
                                            </h3>
                                            <span className="text-xs font-sans text-gray-500 dark:text-gray-400 flex items-center gap-1">
                                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                                </svg>
                                                {room.capacity}
                                            </span>
                                        </div>
                                        <p className="font-body text-sm italic text-gold-600 dark:text-gold-400 mb-3">{room.tagline}</p>
                                        <p className="font-sans text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-4 line-clamp-2">
                                            {room.description}
                                        </p>
                                        <div className="flex flex-wrap gap-2">
                                            {room.features.slice(0, 3).map(feature => (
                                                <span key={feature} className="px-2.5 py-1 rounded-lg bg-gray-100 dark:bg-royal-600/50 text-xs font-sans text-gray-600 dark:text-gray-300">
                                                    {feature}
                                                </span>
                                            ))}
                                            {room.features.length > 3 && (
                                                <span className="px-2.5 py-1 rounded-lg bg-gold-50 dark:bg-gold-500/10 text-xs font-sans text-gold-600 dark:text-gold-400">
                                                    +{room.features.length - 3} more
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>

                    <AnimatedSection className="text-center mt-12">
                        <Link to="/rooms" className="btn-outline text-sm">
                            View All Rooms →
                        </Link>
                    </AnimatedSection>
                </div>
            </section>

            {/* ═══ AMENITIES ═══ */}
            <section className="section-padding">
                <div className="container-custom">
                    <AnimatedSection className="text-center mb-16">
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <div className="w-8 h-px bg-gold-500" />
                            <span className="font-sans text-xs font-semibold tracking-widest uppercase text-gold-600 dark:text-gold-400">
                                What We Offer
                            </span>
                            <div className="w-8 h-px bg-gold-500" />
                        </div>
                        <h2 className="heading-section text-gray-900 dark:text-white mb-4">
                            Amenities & <span className="italic text-gold-600 dark:text-gold-400">Experiences</span>
                        </h2>
                        <p className="text-body-lg text-gray-500 dark:text-gray-400 max-w-2xl mx-auto">
                            Everything you need for a peaceful, memorable stay in the hills.
                        </p>
                    </AnimatedSection>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                        {amenities.map((amenity, index) => (
                            <AnimatedSection key={amenity.id} delay={index * 0.1}>
                                <div className="group glass-card p-8 text-center hover:shadow-xl hover:shadow-gold-500/5 hover:-translate-y-1 transition-all duration-500">
                                    <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gold-50 dark:bg-gold-500/10 flex items-center justify-center text-gold-600 dark:text-gold-400 group-hover:bg-gold-500 group-hover:text-white transition-all duration-500">
                                        <AmenityIcon type={amenity.icon} />
                                    </div>
                                    <h3 className="font-display text-xl font-semibold text-gray-900 dark:text-white mb-3">
                                        {amenity.name}
                                    </h3>
                                    <p className="font-sans text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                                        {amenity.description}
                                    </p>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══ TESTIMONIALS ═══ */}
            <section className="section-padding bg-gray-50 dark:bg-royal-600/20">
                <div className="container-custom">
                    <AnimatedSection className="text-center mb-16">
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <div className="w-8 h-px bg-gold-500" />
                            <span className="font-sans text-xs font-semibold tracking-widest uppercase text-gold-600 dark:text-gold-400">
                                Guest Stories
                            </span>
                            <div className="w-8 h-px bg-gold-500" />
                        </div>
                        <h2 className="heading-section text-gray-900 dark:text-white mb-4">
                            What Our <span className="italic text-gold-600 dark:text-gold-400">Guests</span> Say
                        </h2>
                    </AnimatedSection>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                        {testimonials.map((testimonial, index) => (
                            <AnimatedSection key={testimonial.id} delay={index * 0.15}>
                                <div className="glass-card p-8 h-full flex flex-col">
                                    <div className="flex gap-1 mb-4">
                                        {[...Array(testimonial.rating)].map((_, i) => (
                                            <StarIcon key={i} />
                                        ))}
                                    </div>
                                    <p className="font-body text-lg text-gray-600 dark:text-gray-300 italic leading-relaxed flex-grow mb-6">
                                        "{testimonial.text}"
                                    </p>
                                    <div className="flex items-center gap-3 pt-4 border-t border-gray-200 dark:border-gold-500/10">
                                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center">
                                            <span className="font-sans text-white text-xs font-bold">
                                                {testimonial.name.split(' ').map(n => n[0]).join('')}
                                            </span>
                                        </div>
                                        <div>
                                            <p className="font-sans text-sm font-semibold text-gray-900 dark:text-white">
                                                {testimonial.name}
                                            </p>
                                            <p className="font-sans text-xs text-gray-500 dark:text-gray-400">
                                                {testimonial.location}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </AnimatedSection>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══ CTA ═══ */}
            <section className="relative overflow-hidden">
                <div className="absolute inset-0 bg-[#07250A]" />
                <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '32px 32px' }} />
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent" />

                <div className="relative z-10 section-padding text-center">
                    <AnimatedSection>
                        <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6">
                            Ready for Your <span className="italic text-gold-300">Hill Escape</span>?
                        </h2>
                        <p className="font-body text-xl text-white/70 max-w-2xl mx-auto mb-10">
                            Book your stay at UC Eden Valley and create memories that last a lifetime.
                            The hills are calling.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link to="/contact" className="btn-primary text-base px-10">
                                Book Your Stay
                            </Link>
                            <a
                                href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi! I'd like to know more about UC Eden Valley.`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-outline border-white/30 text-white hover:bg-white/10 hover:border-white/50 text-base px-10"
                            >
                                Chat on WhatsApp
                            </a>
                        </div>
                    </AnimatedSection>
                </div>
            </section>
        </main>
    );
}
